// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//import "dists"

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "@popperjs/core/dist/cjs/popper"
import "bootstrap"
import "overlayscrollbars"
import AnchorJS from 'anchor-js';
import "is_js"
import "echarts"
import "lodash"
import "list.js"
import "@fortawesome/fontawesome-free/js/all";


Rails.start()
Turbolinks.start()
ActiveStorage.start()

window.jQuery = $ 
window.$ = $ 

document.addEventListener("turbolinks:load", () => {
$('.tooltip').tooltip()
  $('[rel="tooltip"]').tooltip()
  $('[data-toggle="tooltip"]').tooltip()
  $('[data-toggle="popover"]').popover()
  $('[data-toggle="dropdown"]').dropdown()
  $('.toast').toast({ autohide: false })
  $('#toast').toast('show')
});

